import axios from 'axios'

var qs = require("qs")
var root = process.env.API_ROOT
var ossipath = process.env.OSSI_Path

//multipart/form-data
//application/x-www-form-urlencoded

//登录
export const login = (params) => {
  return axios.post(ossipath + '/ossi/login', qs.stringify(params), {headers: {"Content-Type": "application/x-www-form-urlencoded"}})
}

export const ssoBuyWeb = (params) => {
  return axios.post(root + '/ossi/ssoBuyWeb', qs.stringify(params), {headers: {"Content-Type": "application/x-www-form-urlencoded"}})
}

//余额
export const accountBalance = (params,ssotoken) => {
  return axios.post(ossipath + '/ossi/accountBalance', qs.stringify(params), {headers: {"Content-Type": "application/x-www-form-urlencoded"}})
}

export const getBalabceRecharge = (params,ssotoken) => {
  return axios.post(ossipath + '/ossi/getBalabceRecharge', qs.stringify(params), {headers: {"Content-Type": "application/x-www-form-urlencoded"}})
}

export const getCashRecharge = (params,ssotoken) => {
  return axios.post(ossipath + '/ossi/getCashRecharge', qs.stringify(params), {headers: {"Content-Type": "application/x-www-form-urlencoded"}});
}

export const getdetailGoods = (params,ssotoken) => {
  return axios.post(ossipath + '/set/jxcgoodsdetail/getdetailapp', qs.stringify(params), {ssotoken: ssotoken,headers: {"Content-Type": "application/x-www-form-urlencoded"}});
}

export const supplyCategory = (params,ssotoken) => {
  return axios.post(ossipath + '/set/jxcgoodscategory/list', qs.stringify(params), {ssotoken: ssotoken,headers: {"Content-Type": "application/x-www-form-urlencoded"}});
}

export const supplyGoods = (params,ssotoken) => {
  return axios.post(ossipath + '/set/jxcgoodsdetail/listapp', qs.stringify(params), {ssotoken: ssotoken,headers: {"Content-Type": "application/x-www-form-urlencoded"}});
}

export const supplyGoodsdetail = (params,ssotoken) => {
  return axios.post(ossipath + '/set/jxcgoodsdetail/getdetailapp', qs.stringify(params), {ssotoken: ssotoken,headers: {"Content-Type": "application/x-www-form-urlencoded"}});
}

export const createOrder = (params,ssotoken) => {
  if(ssotoken.split('?')[0]=='http://thisapi'){
    params["ssosecret"]=ssotoken.split('?')[2];
    return axios.post(root + ssotoken.split('?')[1], qs.stringify(params))
  }else {
    return axios.post(ossipath + '/ossi/createOrder', qs.stringify(params), {
      ssotoken: ssotoken,
      headers: {"Content-Type": "application/x-www-form-urlencoded"}
    });
  }
}

export const checkOrderPay = (params,ssotoken) => {
  return axios.post(ossipath + '/ossi/checkOrderPay', qs.stringify(params), {ssotoken: ssotoken,noloading:true,headers: {"Content-Type": "application/x-www-form-urlencoded"}});
}
export const createFrameOrder = (params,ssotoken) => {
  return axios.post(ossipath + '/zyjossi/createFrameOrder', qs.stringify(params), {ssotoken: ssotoken,headers: {"Content-Type": "application/x-www-form-urlencoded"}});
}
export const supplystoreNum = (params,ssotoken) => {
  return axios.post(ossipath + '/warehouse/store/storeNum', qs.stringify(params), {ssotoken: ssotoken,headers: {"Content-Type": "application/x-www-form-urlencoded"}});
}

export const backOrder = (params,ssotoken) => {
  return axios.post(ossipath + '/ossi/backOrder', qs.stringify(params), {ssotoken: ssotoken,headers: {"Content-Type": "application/x-www-form-urlencoded"}})
}

export const listOrder = (params,ssotoken) => {
  return axios.post(ossipath + '/ossi/listOrder', qs.stringify(params), {ssotoken: ssotoken,headers: {"Content-Type": "application/x-www-form-urlencoded"}})
}

export const detailOrder = (params,ssotoken) => {
  return axios.post(ossipath + '/ossi/detailOrder', qs.stringify(params), {ssotoken: ssotoken,headers: {"Content-Type": "application/x-www-form-urlencoded"}})
}

export const relatedOrder = (params,ssotoken) => {
  return axios.post(ossipath + '/ossi/relatedOrder', qs.stringify(params), {ssotoken: ssotoken,headers: {"Content-Type": "application/x-www-form-urlencoded"}})
}



export const regist = (params) => {
  return axios.post(ossipath + '/ossi/regist', qs.stringify(params), {headers: {"Content-Type": "application/x-www-form-urlencoded"}})
}

export const registCheck = (params) => {
  return axios.post(ossipath + '/ossi/registCheck', qs.stringify(params), {headers: {"Content-Type": "application/x-www-form-urlencoded"}})
}

export const registDraw = (params) => {
  return axios.post(ossipath + '/ossi/registDraw', qs.stringify(params), {headers: {"Content-Type": "application/x-www-form-urlencoded"}})
}

export const listSupplier = (params) => {
  return axios.post(ossipath + '/ossi/listSupplier', qs.stringify(params), {headers: {"Content-Type": "application/x-www-form-urlencoded"}})
}

export const empower = (params) => {
  return axios.post(root + '/ossi/empower', qs.stringify(params), {headers: {"Content-Type": "application/x-www-form-urlencoded"}})
}

export const listempower = (params) => {
  return axios.post(root + '/ossi/listempower', qs.stringify(params), {headers: {"Content-Type": "application/x-www-form-urlencoded"}})
}





// WEBPACK FOOTER //
// ./src/api/ossi.js